// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"chevron-right-double-s"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M7.50195 8.46448L11.0375 12L7.50195 15.5355M12.9629 8.46448L16.4984 12L12.9629 15.5355","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-chevron-right-double-s')
export default class ChevronRightDoubleSIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chevron-right-double-s',
    }
  }
}
